import React, { useEffect, useState } from "react";
import {
  Form,
  message,
  Layout,
  Row,
  Col,
  Spin,
  Typography,
  Button,
} from "antd";
import "./App.css";
import Step1 from "./components/steps/Step1";
import Step2 from "./components/steps/Step2";
import Step3 from "./components/steps/Step3";
import Step4 from "./components/steps/Step4";
import Step5 from "./components/steps/Step5";
import Step6 from "./components/steps/Step6";
import Step7 from "./components/steps/Step7";
import Step8 from "./components/steps/Step8";
import Step9 from "./components/steps/Step9";
import Step10 from "./components/steps/Step10";
import Step11 from "./components/steps/Step11";
import Step12 from "./components/steps/Step12";
import Step13 from "./components/steps/Step13";
import Step14 from "./components/steps/Step14";
import Step15 from "./components/steps/Step15";
import Step16 from "./components/steps/Step16";
import Step17 from "./components/steps/Step17";
import Step18 from "./components/steps/Step18";
import Step19 from "./components/steps/Step19";
import Step20 from "./components/steps/Step20";
import firebase, { auth, firestore, storage } from "firebase/app";
import { refs } from "./firebase/firebase";
import { LoadingOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid"; // Make sure to install and import uuid
import { DriverProvider } from "./context/DriverContext";
import { generatePDF } from "./utils";
import { questions } from "./components/config";
import { quizQuestions } from "./assets/constants";

const { Title, Paragraph } = Typography;

const { Header, Footer, Content } = Layout;

const App = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();
  const [allFormValues, setAllFormValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submissionFailed, setSubmissionFailed] = useState(false);
  let url = [];

  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  console.log("allFormValues: ", allFormValues);

  useEffect(() => {
    const savedSubmissionStatus = localStorage.getItem("submissionStatus");
    if (savedSubmissionStatus === "true") {
      setSubmitted(true);
    }
  }, []);

  // Function to handle logging data and moving to the next step
  const handleNext = async () => {
    try {
      const values = await form.validateFields();
      // console.log(`Data from Step ${currentStep + 1}:`, values); // Log data for the current step

      // Accumulate values into allFormValues state
      setAllFormValues((prevValues) => ({
        ...prevValues,
        ...values,
      }));

      setCurrentStep(currentStep + 1);
    } catch (error) {
      // console.log('Validation failed:', error);
    }
  };

  // const uploadFile = async (file) => {
  //   const storageRef = storage().ref();
  //   const fileRef = storageRef.child(file.name);
  //   await fileRef.put(file.originFileObj); // Use originFileObj to get the file object
  //   return fileRef.getDownloadURL();
  // };

  const uploadFile = async (file) => {
    if (!file) {
      console.error("No file provided for upload");
      return null;
    }
    const uniqueFileName = `${uuidv4()}-${file.name}`;
    // console.log('uniqueFileName: ', uniqueFileName);
    const storageRef = storage().ref();
    const fileRef = storageRef.child(uniqueFileName);
    try {
      await fileRef.put(file.originFileObj);
      return await fileRef.getDownloadURL();
    } catch (error) {
      console.error(`Error uploading file ${file.name}:`, error);
      throw error;
    }
  };

  const handleFinalSubmit = async () => {
    form
      .validateFields()
      .then(async (values) => {
        setAllFormValues((prevValues) => ({
          ...prevValues,
          ...values,
        }));
        // Retrieve and log all form data
        // console.log('All Form Data:', values); // This logs the values from the current form state
        // console.log('All Form allFormValuesallFormValues:', allFormValues); // This logs the values from the current form state

        onFinish(allFormValues);
        // Display the thank you message
        message.success(
          "Thank you for your submission. Your ID Application has been sent."
        );

        // Show downloadable link for the application
        console.log("Downloadable link to application");

        // Reset form and start over
        form.resetFields();
        setCurrentStep(0);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  const getQuestionsAnser = (quizQuestions) => {
    return quizQuestions.reduce((acc, questionObj) => {
      const correctOption = questionObj.options.find(
        (option) => option.correct
      );
      if (correctOption) {
        acc[questionObj.question] = correctOption.label;
      }
      return acc;
    }, {});
  };

  const onFinish = async (values) => {
    //   console.log("values",values);
    //   const mappedValues = questions.reduce((acc, { key, question }) => {
    //     if (values[key] !== undefined) { // Ensure the key exists in values
    //         acc[question] = values[key]; // Map the question to its response
    //     }
    //     return acc;
    // }, {});

    setLoading(true);
    setSubmissionFailed(false); // Reset submission failure state
    try {
      console.log("Starting file uploads with values:", values);

      // Create an array of upload promises
      const uploadPromises = [
        values.photo && values.photo[0] ? uploadFile(values.photo[0]) : null,
        values.licenseFront && values.licenseFront[0]
          ? uploadFile(values.licenseFront[0])
          : null,
        values.drivingHistory && values.drivingHistory[0]
          ? uploadFile(values.drivingHistory[0])
          : null,
        values.previousState && values.previousState[0]
          ? uploadFile(values.previousState[0])
          : null,
        values.criminalHistoryCheck && values.criminalHistoryCheck[0]
          ? uploadFile(values.criminalHistoryCheck[0])
          : null,
        values.licenseRear && values.licenseRear[0]
          ? uploadFile(values.licenseRear[0])
          : null,
        values.taxiDriverAuthority && values.taxiDriverAuthority[0]
          ? uploadFile(values.taxiDriverAuthority[0])
          : null,
      ];

      // Wait for all uploads to complete
      const [
        profilePictureUrl,
        driversLicenseUrl,
        drivingRecordUrl,
        otherStatesRecordUrl,
        backgroundCheckUrl,
        licenseRearUrl,
        taxiDriverAuthorityUrl,
      ] = await Promise.all(uploadPromises);

      console.log("File upload results:", {
        profilePictureUrl,
        driversLicenseUrl,
        drivingRecordUrl,
        otherStatesRecordUrl,
        backgroundCheckUrl,
        licenseRearUrl,
        taxiDriverAuthorityUrl,
      });
      url = [
        driversLicenseUrl,
        drivingRecordUrl,
        otherStatesRecordUrl,
        licenseRearUrl,
        profilePictureUrl,
        backgroundCheckUrl,
        taxiDriverAuthorityUrl,
      ];

      // Extract main fields
      const {
        firstName,
        lastName,
        email,
        address,
        phoneNumber,
        dob,
        licenseExpiry,
        photo,
        licenseFront,
        drivingHistory,
        previousState,
        criminalHistoryCheck,
        taxiDriverAuthority,
        anotherState,
        licenseRear,

        ...rest
      } = values;

      // Convert date objects to timestamps or strings
      const dobTimestamp = dob && dob.toDate ? dob.toDate() : new Date(dob);
      const licenseExpiryTimestamp =
        licenseExpiry && licenseExpiry.toDate
          ? licenseExpiry.toDate()
          : new Date(licenseExpiry);

      // Create extras object with converted date values
      const extras = {
        ...rest,
        dob: dobTimestamp,
        licenseExpiry: licenseExpiryTimestamp,
      };

      console.log("Prepared data for Firestore:", {
        profilePictureUrl,
        driversLicenseUrl,
        drivingRecordUrl,
        otherStatesRecordUrl,
        backgroundCheckUrl,
        licenseRearUrl,
        taxiDriverAuthorityUrl,
        firstName,
        email,
        phoneNumber,
        address,
        extras,
      });
      const consentValues = {
        [`I ${firstName} ${lastName} consent to Opera Taxis Taxi Network entering my driver license into the DVD for the purpose of confirming that I am an eligible driver under point to point transport law. I understand that Opera Taxis Taxi Network will be able to check whether I have the relevant driver licence to provide passenger services and whether I have any disqualifying offences recorded against my name (criminal charges, serious driving offences and point to point safety offences).`]:
          "agree"
      };
      const mappedValues = questions.reduce((acc, { key, question }) => {
        if (values[key] !== undefined) {
          // If the key is "consent", store it separately
          if (key === "consent") {
            consentValues[question] = values[key];
            console.log("here", consentValues);
          } else {
            acc[question] =
              key === "licenseRear"
                ? url[3]
                : key === "licenseFront"
                ? url[2]
                : key === "drivingHistory"
                ? url[1]
                : key === "previousState"
                ? url[0]
                : key === "photo"
                ? url[4]
                : key === "criminalHistoryCheck"
                ? url[5]
                : key === "taxiDriverAuthority"
                ? url[6]
                : values[key];
          }
        }
        return acc;
      }, {});

      // Generate the PDF, adding consent values at the end
      const formResponsesPdf = await generatePDF({
        ...mappedValues,
        ...getQuestionsAnser(quizQuestions),
        ...consentValues, // Append consent values at the end
        
      },allFormValues);
      console.log("formResponsesPdf: ", formResponsesPdf);

      // Add registration data to Firestore

      await refs.registrations.add({
        profilePicture: profilePictureUrl,
        driversLicense: driversLicenseUrl,
        drivingRecord: drivingRecordUrl,
        otherStatesRecord: otherStatesRecordUrl,
        backgroundCheck: backgroundCheckUrl,
        licenseRear: licenseRearUrl,
        name: firstName,
        email,
        phone: phoneNumber,
        address,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        status: "pending",
        extras,
        formResponsesPdf,
      });

      setLoading(false);
      message.success("Registration successful");
      form.resetFields();
      setSubmitted(true);
      localStorage.setItem("submissionStatus", "true");
    } catch (error) {
      setLoading(false);
      console.error("Registration failed:", error);
      message.error("Registration failed. Please try again.");
      setSubmissionFailed(true); // Set submission failure state
    } finally {
      setLoading(false);
      message.success("Registration successful");
      form.resetFields();
      setSubmitted(true);
      localStorage.setItem("submissionStatus", "true");
    }
  };

  const resetForm = () => {
    setSubmitted(false);
    setSubmissionFailed(false);
    localStorage.removeItem("submissionStatus");
    form.resetFields();
    setCurrentStep(0);
  };
  const steps = [
    <Step1 form={form} next={handleNext} />,
    <Step2 form={form} next={handleNext} prev={() => setCurrentStep(0)} />,
    <Step3 form={form} next={handleNext} prev={() => setCurrentStep(1)} />,
    <Step4 form={form} next={handleNext} prev={() => setCurrentStep(2)} />,
    <Step5 form={form} next={handleNext} prev={() => setCurrentStep(3)} />,
    <Step6 form={form} next={handleNext} prev={() => setCurrentStep(4)} />,
    <Step7 form={form} next={handleNext} prev={() => setCurrentStep(5)} />,
    <Step8 form={form} next={handleNext} prev={() => setCurrentStep(6)} />,
    <Step9 form={form} next={handleNext} prev={() => setCurrentStep(7)} />,
    <Step10 form={form} next={handleNext} prev={() => setCurrentStep(8)} />,
    <Step11 form={form} next={handleNext} prev={() => setCurrentStep(9)} />,
    <Step12 form={form} next={handleNext} prev={() => setCurrentStep(10)} />,
    <Step13 form={form} next={handleNext} prev={() => setCurrentStep(11)} />,
    <Step14 form={form} next={handleNext} prev={() => setCurrentStep(12)} />,
    <Step15 form={form} next={handleNext} prev={() => setCurrentStep(12)} />,
    <Step16 form={form} next={handleNext} prev={() => setCurrentStep(12)} />,
    <Step17 form={form} next={handleNext} prev={() => setCurrentStep(10)} />,
    <Step18 form={form} next={handleNext} prev={() => setCurrentStep(12)} />,
    <Step19 form={form} next={handleNext} prev={() => setCurrentStep(13)} />,
    <Step20
      form={form}
      next={handleFinalSubmit}
      prev={() => setCurrentStep(14)}
    />,
  ];

  if (loading) {
    return (
      <div className="full-page-loader">
        <div className="loader-content">
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />}
            tip="Processing your application..."
          />
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Content style={{ padding: "24px" }}>
          <Row justify="center">
            <Col xs={24} sm={20} md={16} lg={12} xl={10}>
              <div style={{ textAlign: "center" }}>
                <Title level={2}>Thank You!</Title>
                <Paragraph>Your ID Application has been sent.</Paragraph>
                <Paragraph>
                  Here is a downloadable link of your application if you would
                  like a copy.
                </Paragraph>
                {/* <Button type="primary" href="/path/to/your/application.pdf" download="ID_Application.pdf">
                  Download Submission PDF
                </Button> */}
                <div style={{ marginTop: "16px" }}>
                  <Button type="default" onClick={resetForm}>
                    Start Over
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    );
  }

  return (
    <DriverProvider>
      <Layout style={{ minHeight: "100vh" }}>
        <Header className="header">
          <h1>Opera Taxis Driver Application</h1>
        </Header>
        <Content style={{ padding: "24px" }}>
          <Row justify="center">
            <Col xs={24} sm={20} md={16} lg={12} xl={10}>
              {submissionFailed ? (
                <div style={{ textAlign: "center" }}>
                  <Title level={2}>Submission Failed</Title>
                  <Paragraph>
                    Sorry, we couldn't submit your application. Please try
                    again.
                  </Paragraph>
                  <Button
                    type="primary"
                    onClick={() => setSubmissionFailed(false)}
                  >
                    Try Again
                  </Button>
                  <div style={{ marginTop: "16px" }}>
                    <Button type="default" onClick={resetForm}>
                      Start Over
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="form-container">{steps[currentStep]}</div>
              )}
            </Col>
          </Row>
        </Content>
        <Footer className="footer">
          <p>© {new Date().getFullYear()} Opera Taxis. All rights reserved.</p>
        </Footer>
      </Layout>
    </DriverProvider>
  );
};

export default App;
